'use client'

import { NavContext } from "@/context/navContext";
import { tabsType } from "@/type/page";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import { useContext, useEffect, useRef, useState } from "react";

type tabTypes = "sub-page" | "box-page"
export default function Tabs(
    { tabs_path, col, type, setContent }: 
    { tabs_path: tabsType[], col?: number, type?: tabTypes, setContent?:(id: number | undefined) => void }
) {
    const { movePage } = useContext(NavContext)
    const tabsRef = useRef<HTMLDivElement>(null)

    const t = useTranslations("PageTitle");
    const pathName = usePathname()

    useEffect(() => {
        if(!col){
            tabsRef.current?.style.setProperty('--col', `${tabs_path.length}`);
        }else{
            tabsRef.current?.style.setProperty('--col', `${col}`);
        }
        if(setContent) setContent(undefined)
    }, [tabs_path])

    return (

        <div className={`page-tabs-new`}>
            <div ref={tabsRef} 
                 className={type ? type : "sub-page"}>
                {
                    tabs_path.map((tab, index) => (
                        <div key={index}
                            className={`${pathName == tab.path ? "active" : ""} ${tab.disabled ? "disabled" : ""} cursor-pointer`}
                            onClick={e => {
                                // console.log(tab)
                                if(tab.callBack){
                                    tab.callBack()
                                }else{
                                    movePage(tab.path)
                                }
                            }} >
                                <span className="label">{t(tab.name)}</span>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}